import React, { useEffect, useState, useRef } from "react";
// import moment from "moment-timezone";
import "../../../styles/live-subscriptions/membership-notification.css";
// import notificationSound from "../../../assets/sounds/member_success_checkin.mp3";
import notificationSound from "../../../assets/vocal-sound/vocal_member_checkin.mp3";
// import {
//   CalenderIcon1,
//   CallIcon,
//   LocationIcon1,
//   PersonIcon,
// } from "../../../images/icons/icons";
// import { formatDateTime } from "../../common-data/Converts";
import MemberBasicInfo from "../MemberBasicInfo";
import FooterTags from "../FooterTags";
import ToaserInfo from "../ToaserInfo";

const CheckinsWebhook = ({ userInfoData, setStatsData, setAllDatas }) => {
  const audioRef = useRef(null);
  const wsRef = useRef(null);
  const wsBackoffRef = useRef(2000);
  const processedWebhookEvents = useRef(new Set());

  const [notifications, setNotifications] = useState([]);
  const [activeTab, setActiveTab] = useState(0);

  const isIOS = () => /iPad|iPhone|iPod/.test(navigator.userAgent);

  const playNotificationSound = () => {
    try {
      if (audioRef.current) {
        audioRef.current.currentTime = 0;
        audioRef.current.play().catch((error) => {});
      }
    } catch (error) {}
  };

  const showCheckinNotification = (checkinData) => {
    console.log("checkinData=> ", checkinData);

    const eventId = `${checkinData?.member_name || ""}_${
      checkinData?.mobile || ""
    }_${checkinData?.checkin_date_time || ""}_${Date.now()}`;

    const now = Date.now();
    const existingEvent = Array.from(processedWebhookEvents.current).find(
      (item) => {
        const [id, timestamp] = item.split("_TIMESTAMP_");
        return (
          id.includes(checkinData?.member_name || "") &&
          id.includes(checkinData?.mobile || "") &&
          now - parseInt(timestamp) < 10000
        );
      }
    );

    if (existingEvent) {
      return;
    }

    const eventWithTimestamp = `${eventId}_TIMESTAMP_${now}`;
    processedWebhookEvents.current.add(eventWithTimestamp);

    processedWebhookEvents.current.forEach((item) => {
      const [, timestamp] = item.split("_TIMESTAMP_");
      if (now - parseInt(timestamp) > 30000) {
        processedWebhookEvents.current.delete(item);
      }
    });

    const notification = checkinData || {};
    // const notification = {
    //   member_name: checkinData?.member_name || checkinData?.name || "NA",
    //   name: checkinData?.name || checkinData?.member_name || "NA",
    //   mobile: checkinData?.mobile || "NA",
    //   type: checkinData?.type || "NA",
    //   profile: checkinData?.profile || null,
    //   cover_image: checkinData?.cover_image || null,
    //   checkin_date_time:
    //     checkinData?.checkin_date_time ||
    //     moment().tz("Asia/Kolkata").format("YYYY-MM-DD HH:mm:ss"),
    //   gym_name: checkinData?.gym_name || "NA",
    //   gym_id: checkinData?.gym_id || null,
    //   date_added:
    //     checkinData?.date_added ||
    //     moment().tz("Asia/Kolkata").format("YYYY-MM-DD HH:mm:ss"),
    //   is_renewal: checkinData?.is_renewal || 0,
    //   timestamp: Date.now(),
    // };

    setNotifications((prev) => {
      const newNotifications = [notification, ...prev];

      return newNotifications;
    });
    playNotificationSound();

    if (setStatsData) {
      setStatsData((prev) => {
        const currentTotal = Number(prev.total) || 0;
        const currentRegular = Number(prev.regular_subscriptions) || 0;
        const currentPT = Number(prev.personal_training) || 0;
        const currentCheckins = Number(prev.total_checkins) || 0;

        const isPersonalTraining =
          checkinData?.type === "addont_pt" || checkinData?.type === "pt";

        return {
          ...prev,
          total: currentTotal + 1,
          regular_subscriptions: isPersonalTraining
            ? currentRegular
            : currentRegular + 1,
          personal_training: isPersonalTraining ? currentPT + 1 : currentPT,
          total_checkins: currentCheckins + 1,
        };
      });
    }

    if (setAllDatas) {
      setAllDatas((prev) => ({
        ...prev,
        allData: [notification, ...prev.allData],
      }));
    }

    setTimeout(() => {
      setNotifications((prev) => {
        const updated = prev.filter((n) => n.id !== notification.id);
        if (activeTab >= updated.length && updated.length > 0) {
          setActiveTab(updated.length - 1);
        }
        return updated;
      });
    }, 95000);
  };

  useEffect(() => {
    const WS_URL = process.env.REACT_APP_ODM_WSS_URL;
    if (!WS_URL || !userInfoData || isIOS()) return;

    let stopped = false;

    const computeChannels = () => {
      try {
        const acc = userInfoData?.account_type;
        const channels = [];

        if (acc === "receptionist" && userInfoData?.gym_id) {
          channels.push(`checkin:gym:${userInfoData.gym_id}`);
        }
        if (acc === "cluster_manager") {
          const userGyms = userInfoData?.gyms?.gyms || userInfoData?.gyms || [];
          if (Array.isArray(userGyms)) {
            userGyms.forEach((g) => {
              const gid = g?.value || g?.gym_id || g?.uid || g;
              if (gid) channels.push(`checkin:gym:${gid}`);
            });
          }
        }
        if (acc === "admin") {
          channels.push("checkin:global");
        }

        return Array.from(new Set(channels));
      } catch {
        return [];
      }
    };

    const connect = () => {
      if (stopped) return;
      try {
        const token = encodeURIComponent(userInfoData?.token || "");
        const ws = new WebSocket(`${WS_URL}?token=${token}&type=checkin`);
        wsRef.current = ws;

        ws.onopen = () => {
          wsBackoffRef.current = 2000;
          const channels = computeChannels();

          try {
            ws.send(
              JSON.stringify({
                type: "SUBSCRIBE",
                channels: channels,
                event_filter: ["member_success_checkin"],
              })
            );
          } catch (e) {}
        };

        ws.onmessage = (e) => {
          try {
            const msg = JSON.parse(e.data);

            if (
              msg?.event_type === "member_success_checkin" &&
              msg?.data &&
              msg?.status
            ) {
              showCheckinNotification(msg.data);
            } else {
            }
          } catch (err) {}
        };

        ws.onclose = () => {
          if (stopped) return;
          const delay = Math.min(wsBackoffRef.current, 30000);
          setTimeout(connect, delay);
          wsBackoffRef.current = Math.min(wsBackoffRef.current * 2, 30000);
        };

        ws.onerror = () => {
          try {
            ws.close();
          } catch {}
        };
      } catch {
        const delay = Math.min(wsBackoffRef.current, 30000);
        setTimeout(connect, delay);
        wsBackoffRef.current = Math.min(wsBackoffRef.current * 2, 30000);
      }
    };

    connect();

    return () => {
      stopped = true;
      try {
        if (wsRef.current && wsRef.current.readyState === 1) {
          wsRef.current.close();
        }
      } catch {}
    };
  }, [userInfoData]);

  useEffect(() => {
    if (audioRef.current) {
      const audio = audioRef.current;

      audio.addEventListener("loadstart", () => {});

      audio.addEventListener("canplay", () => {});

      audio.addEventListener("canplaythrough", () => {});

      audio.addEventListener("error", (e) => {});

      audio.load();
    }
  }, []);

  useEffect(() => {
    if (notifications.length > 0) {
      setActiveTab(0);
    }
  }, [notifications.length]);

  // const testAudio = () => {
  //   if (audioRef.current) {
  //     audioRef.current.currentTime = 0;
  //     audioRef.current
  //       .play()
  //       .then(() => {})
  //       .catch((error) => {});
  //   }
  // };

  return (
    <>
      <audio
        ref={audioRef}
        preload="auto"
        src={notificationSound}
        style={{ display: "none" }}
      />

      {/* <button
        onClick={testAudio}
        style={{
          position: "fixed",
          top: "10px",
          left: "10px",
          zIndex: 10000,
          padding: "10px",
          background: "red",
          color: "white",
          border: "none",
        }}
      >
        🔊 Test Checkin Audio
      </button> */}

      {notifications.length > 0 && (
        <div className="live-subscription-membership-notifications-container">
          <div className="live-subscription-feed-modal">
            <div className="live-subscription-modal-header">
              <div>
                <h2 className="live-subscription-modal-title">
                  Member Checkin Feed
                </h2>
                <p className="live-subscription-active-count">
                  {notifications.length} Recent Checkins
                </p>
              </div>
              <button
                className="live-subscription-close-modal-btn"
                onClick={() => setNotifications([])}
              >
                ×
              </button>
            </div>

            <div className="live-subscription-tab-navigation">
              {notifications.map((notification, index) => {
                return (
                  <button
                    key={notification.id}
                    className={`live-subscription-tab-item ${
                      index === activeTab ? "active" : ""
                    }`}
                    onClick={() => setActiveTab(index)}
                  >
                    #{index + 1}
                  </button>
                );
              })}
            </div>

            {notifications[activeTab] && (
              <div className="live-subscription-membership-notification-card">
                {/* <div className="live-subscription-member-info-section">
                  <div className="live-subscription-member-basic-info">
                    <div className="live-subscription-member-name">
                      <div className="live-subscription-member-name-left">
                        <PersonIcon />
                        {notifications[activeTab]?.name || "NA"}
                      </div>
                      {(notifications[activeTab]?.is_renewal === 1 ||
                        notifications[activeTab]?.is_renewal === 0) && (
                        <span
                          className={`tb-badge ${
                            notifications[activeTab]?.is_renewal === 1
                              ? "tb-existing"
                              : notifications[activeTab]?.is_renewal === 0
                              ? "tb-fresh"
                              : ""
                          }`}
                        >
                          {notifications[activeTab]?.is_renewal === 1
                            ? "Existing Member"
                            : notifications[activeTab]?.is_renewal === 0
                            ? "Fresh"
                            : "NA"}
                        </span>
                      )}
                    </div>
                    <div className="live-subscription-member-phone">
                      <CallIcon />
                      {notifications[activeTab]?.mobile || "NA"}
                    </div>
                    <div className="live-subscription-gym-location">
                      <LocationIcon1 />
                      {notifications[activeTab]?.gym_name || "NA"}
                    </div>
                  </div>
                </div> */}

                {/* <div className="live-subscription-subscription-details">
                  {notifications[activeTab]?.trainer_name ? (
                    <div className="live-subscription-detail-item">
                      <div className="live-subscription-detail-icon">
                        <PersonIcon />
                      </div>
                      <div className="live-subscription-detail-label">
                        Trainer
                      </div>
                      <div className="live-subscription-detail-value">
                        {notifications[activeTab].trainer_name || "-"}
                      </div>
                    </div>
                  ) : null}

                  {notifications[activeTab]?.trainer_mobile ? (
                    <div className="live-subscription-detail-item">
                      <div className="live-subscription-detail-icon">
                        <CallIcon />
                      </div>
                      <div className="live-subscription-detail-label">
                        Trainer Mobile
                      </div>
                      <div className="live-subscription-detail-value">
                        {notifications[activeTab].trainer_mobile || "-"}
                      </div>
                    </div>
                  ) : null}

                  <div className="live-subscription-detail-item">
                    <div className="live-subscription-detail-icon">
                      <CalenderIcon1 />
                    </div>
                    <div className="live-subscription-detail-label">
                      Checkin Time
                    </div>
                    <div className="live-subscription-detail-value">
                      {formatDateTime(
                        notifications[activeTab]?.checkin_date_time || "-"
                      )}
                    </div>
                  </div>

                  <div className="live-subscription-detail-item">
                    <div className="live-subscription-detail-icon">
                      <PersonIcon />
                    </div>
                    <div className="live-subscription-detail-label">
                      Member Type
                    </div>
                    <div className="live-subscription-detail-value">
                      {notifications[activeTab]?.type || "-"}
                    </div>
                  </div>

                  <div className="live-subscription-detail-item span2">
                    <div className="live-subscription-detail-icon">
                      <CalenderIcon1 />
                    </div>
                    <div className="live-subscription-detail-label">
                      subscription add date
                    </div>
                    <div className="live-subscription-detail-value">
                      {formatDateTime(
                        notifications[activeTab]?.date_added || "-"
                      )}
                    </div>
                  </div>
                </div> */}

                {/* <div className="live-subscription-total-amount-section">
                  <div className="live-subscription-total-amount-label">
                    <PersonIcon />
                    Member Profile
                  </div>
                  <div className="live-subscription-total-amount-value">
                    {notifications[activeTab]?.profile ? (
                      <img
                        src={notifications[activeTab].profile}
                        alt="Profile"
                        className="live-subscription--img"
                      />
                    ) : (
                      "No Image"
                    )}
                  </div>
                </div> */}

                {/* <div className="live-subscription-membership-badges">
                  <div className="live-subscription-membership-badge regular">
                    Checkin Success
                  </div>
                  <div className="live-subscription-membership-badge plan">
                    {notifications[activeTab]?.type === "addont_pt"
                      ? "PT"
                      : notifications[activeTab]?.type || "NA"}{" "}
                    Member
                  </div>
                </div> */}

                <MemberBasicInfo
                  rowData={notifications[activeTab]}
                  customTitle="Checked-In Member"
                />

                <ToaserInfo
                  from="member_checkins"
                  rowData={notifications[activeTab]}
                />

                <FooterTags
                  from="member_checkins"
                  rowData={notifications[activeTab]}
                />
              </div>
            )}
          </div>
        </div>
      )}
    </>
  );
};

export default CheckinsWebhook;
